<template>
  <div
    class="w-full pt-[155px] text-[26px] leading-[36px] text-green-700 font-primary font-semibold text-center flex flex-col items-center px-6"
  >
    <div class="w-full max-w-[450px] flex flex-col flex-grow">
      <div class="w-[250px] tablet-v:w-full mx-auto">
        Let's personalize Dacr for you.
      </div>

      <UiButton class="mt-auto w-full" primary large @click="handleClick">
        Next
      </UiButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import { useOnboardingStore } from '@/features/onboarding/store'
import { UiButton } from '@dacr/ui'

const { mutate: completeStep } = useCompleteStepMutation()

const onboardingStore = useOnboardingStore()

const handleClick = () => {
  completeStep({
    step: 1,
  })

  onboardingStore.goToNextStep()
}
</script>
